import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/user-access/`;

export const fetchUserRequestData = async (applicationType) => {
    const url = `${userRolesUrl}fetchRequestStatus?applicationType=${applicationType}`;
    const response = await ApiService.get(url);
    return response.data;
}

export const fetchApproverRequestStatuses = async (applicationType) => {
  const url = `${userRolesUrl}fetchRequestForApproval?applicationType=${applicationType}`;
  const response = await ApiService.get(url);
  return response.data;
};

export const updateApproverAction = async (payload) => {
  const url = `${userRolesUrl}handleApprovalRequest`;
  const response = await ApiService.post(url, payload);
  return response.data;
};